var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { calcTotal } from "features/coins/lib";
import { useBalances, useCoinsData } from "hooks";
function useTotalPortfolio() {
    var queryClient = useQueryClient();
    var _a = useCoinsData().data, coins = _a === void 0 ? [] : _a;
    var balances = useBalances().balances;
    var profileData = queryClient.getQueryData(["profile"]);
    var computedTotalHoldings = useMemo(function () {
        if (coins.length === 0 || !balances || !profileData)
            return 0;
        var cacheBalances = (profileData.coinBalances || []).reduce(function (acc, curr) {
            acc[curr.symbol] = curr.balance;
            return acc;
        }, {});
        return coins.reduce(function (sum, coin) {
            var _a, _b;
            var symbol = coin.title || "";
            var price = coin.price || 0;
            var owned = (_b = (_a = cacheBalances[symbol]) !== null && _a !== void 0 ? _a : coin.owned) !== null && _b !== void 0 ? _b : 0;
            var total = calcTotal(__assign(__assign({}, coin), { title: symbol, owned: owned }), balances, price);
            return sum + (total !== null && total !== void 0 ? total : 0);
        }, 0);
    }, [balances, coins, profileData]);
    return computedTotalHoldings;
}
export default useTotalPortfolio;
